import { render, staticRenderFns } from "./OutputPCDashboard.vue?vue&type=template&id=458e5e40&"
import script from "./OutputPCDashboard.vue?vue&type=script&lang=js&"
export * from "./OutputPCDashboard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VDivider,VRow})


/* hot reload */
if (module.hot) {
  var api = require("/builds/saas-tool/client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('458e5e40')) {
      api.createRecord('458e5e40', component.options)
    } else {
      api.reload('458e5e40', component.options)
    }
    module.hot.accept("./OutputPCDashboard.vue?vue&type=template&id=458e5e40&", function () {
      api.rerender('458e5e40', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/OutputPCDashboard.vue"
export default component.exports